<template>
  <div class="table_actions">
    <div class="table_actions__items">
      <div class="table_actions__group">
        <button
          v-if="deleteButtonLabel"
          type="button"
          :class="{ disabled: numberOfSelectedItems === 0 }"
          class="action_button_red"
          @click="onDeleteSelected"
          :disabled="numberOfSelectedItems === 0 || loading"
        >
          <span class="action_label">{{ deleteButtonLabel }}</span>
          <font-awesome-icon :icon="['far', 'trash-alt']" />
        </button>
        <button
          v-if="exportButtonLabel"
          type="button"
          :class="{ disabled: numberOfSelectedItems === 0 }"
          class="action_button_blue"
          @click="onExportSelected"
          :disabled="numberOfSelectedItems === 0 || loading"
        >
          <span class="action_label">{{ exportButtonLabel }}</span>
          <font-awesome-icon :icon="['far', 'cloud-download']" />
        </button>
      </div>
      <div class="table_actions__group">
        <button
          v-if="addButtonLabel"
          :class="{ disabled: loading }"
          :disabled="loading"
          type="button"
          class="action_button_blue"
          @click="onAddItems"
        >
          <span class="action_label">{{ addButtonLabel }}</span>
          <font-awesome-icon :icon="['far', 'plus']" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTrashAlt,
  faPlus,
  faCloudDownload,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faTrashAlt, faPlus, faCloudDownload);

export default {
  name: "TableActions",
  components: {
    FontAwesomeIcon,
  },
  props: {
    numberOfSelectedItems: {
      type: Number,
      required: true,
    },
    deleteButtonLabel: {
      type: String,
    },
    exportButtonLabel: {
      type: String,
    },
    addButtonLabel: {
      type: String,
    },
    loading: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    onDeleteSelected() {
      this.$emit("deleteSelected");
    },
    onExportSelected() {
      this.$emit("exportSelected");
    },
    onAddItems() {
      this.$emit("addItems");
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../style_variables/style_variables.scss";

.table_actions {
  width: 100%;
}
.table_actions__items {
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table_actions__group {
  display: flex;
  gap: 20px;
}

.action_label {
  padding-right: 8px;
}

.action_button_blue,
.action_button_red {
  @extend %button_typography_style;
  border: none;
  background-color: $white;
  cursor: pointer;
  padding: 0;
}

.action_button_red {
  color: $red;
  &:hover {
    color: $red_maroon;
  }
}

.action_button_blue {
  color: $blue;
  &:hover {
    color: $blue_sapphire;
  }
}

.disabled {
  color: $grey_bombay;
  cursor: default;
  &:hover {
    color: $grey_bombay;
  }
}
</style>
